export const LOGIN_USER = 'LOGIN_USER';
export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';



// WEBPACK FOOTER //
// ./src/actions/types.ts